import Vue from 'vue'
import VueMaterial from 'vue-material'
import { MdButton, MdContent, MdTabs } from 'vue-material/dist/components'
import VueMaterialIcon from 'vue-material-icon'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material-design-icons/styles.css'

Vue.component(VueMaterialIcon.name, VueMaterialIcon)
Vue.use(VueMaterial)
Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdTabs)
